module.exports = __webpack_public_path__ + "static/media/video.b4273248.svg";